import React, { useEffect, useState } from "react";
import {
  Box,
  Container,
  Heading,
  SimpleGrid,
  VStack,
  Image,
  Text,
  IconButton,
  useColorMode,
} from "@chakra-ui/react";
import { motion } from "framer-motion";
import { FiPlay, FiHeart } from "react-icons/fi";
import axios from "axios";
import { useMusic } from "../context/MusicContext";

const MotionBox = motion(Box);

const Home = () => {
  const { colorMode } = useColorMode();

  // Mock data for new songs
  const [newSongs, setNewSong] = useState([]);
  const [isloading, setIsloading] = useState(false);

  const { audioRef, currentTime, currentTrack, setCurrentTrack, setIsPlaying } =
    useMusic();

  useEffect(() => {
    setIsloading(true);
    axios
      .get("https://apiArmanify.zx-tm.ir/api/songs/featured")
      .then((response) => {
        setNewSong(response.data);
        setIsloading(false);
      })
      .catch((error) => {
        console.error(error);
        setIsloading(false);
      });
    
  }, []); // فقط یک بار هنگام mount اجرا میشه

  function play(url) {
    axios
      .get(`https://apiArmanify.zx-tm.ir/api/songs/music?url=${url}`)
      .then((response) => {
        setCurrentTrack({
          page_url: url,
          title: response.data.title,
          artist: response.data.title,
          cover: response.data.coverUrl,
          url: response.data.mp3Url,
          duration: 0,
        });
        setIsPlaying(true);

      })
      .catch((error) => {
        console.error(error);
      });
  }

  return (
    <Container maxW="container.xl" py={8}>
      <VStack spacing={8} align="stretch">
        <Heading size="xl">آهنگ‌های جدید</Heading>
        <SimpleGrid columns={{ base: 1, sm: 2, md: 3, lg: 4 }} spacing={6}>
          {newSongs.map((song, index) => (
            <MotionBox
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3, delay: index * 0.1 }}
            >
              <Box
                bg={colorMode === "dark" ? "gray.700" : "white"}
                borderRadius="xl"
                overflow="hidden"
                boxShadow="lg"
                position="relative"
                _hover={{ transform: "translateY(-4px)" }}
                transition="transform 0.2s"
              >
                <Image
                  src={song.imageUrl}
                  alt={song.title}
                  w="100%"
                  h="200px"
                  objectFit="cover"
                />
                <Box p={4}>
                  {/* <Text fontWeight="bold" fontSize="lg">
                    {song.title}
                  </Text> */}
                  <Text color={colorMode === "dark" ? "whitesmoke" : "black"}>{song.title}</Text>
                </Box>
                <Box
                  position="absolute"
                  top={2}
                  right={2}
                  display="flex"
                  gap={2}
                >
                  <IconButton
                    onClick={() => play(song.link)}
                    icon={<FiPlay />}
                    colorScheme="brand"
                    size="sm"
                    aria-label="Play"
                  />
                </Box>
              </Box>
            </MotionBox>
          ))}
          <span
            className="loader"
            style={{ display: isloading ? "block" : "none" }}
          ></span>
        </SimpleGrid>
      </VStack>
    </Container>
  );
};

export default Home;
